module.exports = __webpack_public_path__ + "static/media/Multimodal.f6907ba8.jpg";